import PropTypes from 'prop-types';

export const fxRatesErrorPropTypes = {
	id: PropTypes.string,
	code: PropTypes.string,
	message: PropTypes.string,
	metadata: PropTypes.shape({
		reason: PropTypes.string,
	}),
};

const fxProptypes = {
	rate: PropTypes.string,
	type: PropTypes.oneOf(['PRE_BOOKED_RATE', 'sheet', 'live']),
	validity_duration: PropTypes.string,
};

const paymentAmountPropTypes = {
	type: PropTypes.string,
	value: PropTypes.string,
	currency: PropTypes.string,
};

const detailsPropTypes = {
	value_date: PropTypes.string,
	payment_amount: PropTypes.arrayOf(PropTypes.shape(paymentAmountPropTypes)),
	charge_amount: PropTypes.arrayOf(PropTypes.shape(paymentAmountPropTypes)),
	source_id: PropTypes.string,
	pei_id: PropTypes.string,
};

export const fxRatesPropTypes = {
	[PropTypes.string]: PropTypes.shape({
		fx: PropTypes.shape(fxProptypes),
		pei_bulk_id: PropTypes.string,
		indicative: PropTypes.bool,
		details: PropTypes.arrayOf(PropTypes.shape(detailsPropTypes)),
	}),
};

export const ratesPropTypes = {
	error: PropTypes.oneOf([undefined, PropTypes.shape(fxRatesErrorPropTypes)]),
	fxRates: PropTypes.shape(fxRatesPropTypes),
};

export const fxChargesProptypes = {
	[PropTypes.string]: PropTypes.arrayOf(PropTypes.shape(paymentAmountPropTypes)),
};
